export const datatable = {
  page: 'Strona',
  outOf: 'z',
  countSize: 'Liczba rekordów na stronę',
  showing: 'Wyświetlanie',
  showingCont: 'rekordów z',
  choose: 'Wybierz',
  notFoundField: 'Nie znaleziono pola',
  searchPlaceholder: 'Znajdź krok',
  resetColumns: 'Przywróć domyślne',
  saveForAllUsers: 'Zapisz wszystkim',
  saveForAllConfirmTitle: 'Czy na pewno?',
  saveForAllConfirmDescription:
    'Ta konfiguracja kolumn zostanie ustawiona jako domyślna dla wszystkich użytkowników.',
  columnsSavedForAll: 'Zapisano ustawienia kolumn dla wszystkich użytkowników.',
  resetConfirmTitle: 'Czy na pewno?',
  resetConfirmDescription:
    'Twoja zapisana konfiguracja kolumn zostanie usunięta, a widok wróci do wartości domyślnych.',
  columnsReset: 'Przywrócono domyślne ustawienia kolumn.',
}
